<template>
  <div>
    <KDSList />
    <KdsAdminDashboard v-if="isAdmin" />
  </div>
</template>

<script>
import KDSList           from '../partials/kds.vue';
import KdsAdminDashboard from './KdsAdminDashboard.vue';

export default {
  name: 'KDS',
  components: { KDSList, KdsAdminDashboard },

  computed: {
    isAdmin() {
      const roles = this.$store?.state?.userDetails?.roles || [];
      return roles.some(r => {
        const name = (r.name || r || '').toString();
        return ['Admin', 'Super Admin', 'admin'].includes(name);
      });
    },
  },
};
</script>
